import { Link, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import ManhwaCard from '@/components/feature/ManhwaCard';
import useSeo from '@/hooks/useSeo';
import { genres, manhwaList, getGenreById, getManhwaByGenre } from '@/mocks/manhwa';

export default function CategoryPage() {
  const { genre = 'romance' } = useParams();
  const current = getGenreById(genre) ?? genres[0];
  const activeId = current.id;
  const list = getManhwaByGenre(activeId);
  const others = manhwaList.filter((m) => m.genre !== activeId).slice(0, 4);

  useSeo({
    title: `漫画韩漫网址${current.name} - ${current.desc}`,
    description: `漫画韩漫网址${current.name}题材分类，收录${current.count}部${current.name}韩漫，${current.desc}。`,
  });

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://suspensek.github.io/' },
              { '@type': 'ListItem', position: 2, name: `${current.name}韩漫`, item: `https://suspensek.github.io/category/${activeId}` },
            ],
          }),
        }}
      />
      <Navbar />

      <main className="pt-24 md:pt-32 pb-16 md:pb-24 bg-background-50 min-h-screen">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          {/* 面包屑 */}
          <nav aria-label="面包屑导航" className="mb-8">
            <ol className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
              <li>
                <Link to="/" className="hover:text-primary-600 whitespace-nowrap">首页</Link>
              </li>
              <li aria-hidden="true"><i className="ri-arrow-right-s-line"></i></li>
              <li aria-current="page" className="text-foreground-800 whitespace-nowrap">{current.name}韩漫</li>
            </ol>
          </nav>

          {/* 题材切换 */}
          <div className="flex flex-wrap gap-2 mb-10">
            {genres.map((g) => (
              <Link
                key={g.id}
                to={`/category/${g.id}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                  g.id === activeId
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700 border border-background-200'
                }`}
              >
                <i className={`${g.icon} mr-1.5`} aria-hidden="true"></i>
                {g.name}韩漫
              </Link>
            ))}
          </div>

          {/* 分类标题 */}
          <header className="mb-10">
            <div className="flex items-start gap-5">
              <span className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-100 text-primary-700 flex items-center justify-center shrink-0">
                <i className={`${current.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <div>
                <h1 className="font-heading text-2xl md:text-4xl text-foreground-950">
                  漫画韩漫网址{current.name}题材
                </h1>
                <p className="mt-2 text-sm md:text-base text-foreground-600">{current.desc}，已收录 {current.count} 部优质韩漫。</p>
              </div>
            </div>
          </header>

          {/* 内容列表 */}
          <section aria-label={`${current.name}韩漫列表`}>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
              {list.map((m) => (
                <ManhwaCard key={m.id} manhwa={m} />
              ))}
            </div>
          </section>

          {/* 其他题材推荐 */}
          <section className="mt-16 pt-10 border-t border-background-200" aria-label="其他题材推荐">
            <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-6">其他题材也值得一看</h2>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-5">
              {others.map((m) => (
                <ManhwaCard key={m.id} manhwa={m} />
              ))}
            </div>
          </section>
        </div>
      </main>

      <Footer />
      <BackToTop />
    </>
  );
}